export default {
  AddFix: 'Report a repair',
  searchorder: 'Search repair number',
  placeholderOrderFix: 'Repair number',
  searchworkerid: 'Search worker ID',
  workerid: 'Employee ID',
  searchUser: 'Search user',
  user: 'Username',
  email: 'Email',
  password: 'Password',
  phone: 'Phone number',
  jobtitle: 'Job title',
  searchEmail: 'Search by email',
  emailname: 'Email name',
  searchdept: 'Search by department name',
  deptname: 'Department name',
  searchrole: 'Search by user role',
  role: 'User role',
  uppersearchrole: 'All uppercase (USER)',
  startDate: 'Select start date',
  endDate: 'Select end date',
  search: 'Search',
  WaitImprove: 'Waiting for approval',
  fixstatus: 'Report repair',
  fixing: 'Repair in progress',
  claim: 'Claim/Send for repair',
  confirmjob: 'Awaiting inspection',
  cancelSucc: 'Cancelled/Successful',
  nofix: 'No repair request',
  allfixjob: 'All repair requests',
  showfixjob: 'Show repair job',
  returnfixjob: 'Return repair job',
  deviceedit: 'Manage device',
  fixedit: 'Manage repair',
  allimprove: 'Approve all',
  fixcancel: 'Cancel repair',
  fixcancelDetails: 'Cancellation remarks',
  fixcancelDetailsinput: 'Enter cancellation remarks',
  cancelconfirm: 'Confirm cancellation',
  cancel: 'Cancel',
  rate: 'Rating',
  ratescore: 'Score (1 = lowest, 5 = highest)',
  comment: 'Comment',
  commentInput: 'Enter comment',
  sendcomment: 'Submit feedback',
  thankForhelp: 'Thank you for your cooperation',
  thankForhelpText: 'Thank you for your cooperation in the evaluation!',
  close: 'Close',
  loading: 'Loading data...',
  getfixjob: 'Date received',
  fixDate: 'Repair date',
  cate: 'Category',
  subcate: 'Subcategory',
  device: 'Device',
  fixDetails: 'Repair details',
  problem: 'Cause/Problem',
  operator: 'External technician',
  operatorinput: 'Enter external technician',
  status: 'Status',
  management: 'Management',
  worker: 'Repair operator',
  fixinfo: 'Repair information',
  typefix: 'Repair type',
  subcatefix: 'Repair subcategory',
  deviceinfo: 'Device information',
  devicecate: 'Main device category',
  devicesubcate: 'Device subcategory',
  fixinfodetails: 'Repair details',
  fixdetailstitle: 'Repair details',
  problemdetails: 'Enter problem details',
  problemdetailsinput: 'Enter problem details',
  text150: 'Please enter a message no longer than 150 characters',
  text100: 'Please enter a message no longer than 100 characters',
  text50: 'Please enter a message no longer than 50 characters',
  text30: 'Please enter a message no longer than 30 characters',
  image: 'Image',
  imageinfo: 'Image information',
  addimage: 'Add image/document',
  addimagefix: 'Add post-repair image/document',
  submit: 'Save',
  notification: 'Notification',
  confirm: 'Confirm',
  noticdetailsfix: 'Please enter correct repair details',
  text: 'Text',
  selectimage: 'Select image/document file',
  notfoundsubcate: 'Subcategory not found',
  warning: 'Warning',
  error: 'Error',
  getsubcatefailed: 'Failed to retrieve subcategory data',
  notfoundsubcateIndevice: 'No device data found in this subcategory',
  getdevicefailed: 'Failed to retrieve device data',
  notfoundsubcatedevice: 'No device data found in this subcategory',
  getsubcatedevicefailed: 'Failed to retrieve subcategory data for the device',
  expenseinfo: 'Expense information',
  addexpense: 'Add expense',
  selectcateexpense: 'Select expense category',
  expense: 'Expense Per Unit',
  remark: 'Remark',
  remarkinput: 'Enter remark',
  sum: 'Total',
  totalcost: 'Total cost',
  spareinfo: 'Spare part information',
  spare: 'Spare parts',
  addlist: 'Add item',
  list: 'List',
  listinput: 'Enter item',
  orderbuy: 'Purchase order number',
  orderbuyinput: 'Enter purchase order number',
  amount: 'Quantity',
  amountinput: 'Enter quantity',
  cost: 'Cost',
  sourcespare: 'Spare part source',
  sourcespareinput: 'Enter spare part source',
  fixdetails: 'Problem details',
  fixdetailsinput: 'Enter problem details',
  reasondetails: 'Cause details',
  reasondetailsinput: 'Enter cause details',
  solution: 'Solution details',
  solutioninput: 'Enter solution/repair details',
  admindetails: 'Admin details',
  requesttype: 'Request type',
  Expectedcompletion: 'Expected completion date',
  fixdone: 'Completion date',
  expenseSubcateName: 'Expense subcategory',
  expenseCateName: 'Expense category',
  change: 'Change',
  fix: 'Repair',
  check: 'Check',
  orderlist: 'Order',
  deleteconfirm: 'Do you want to delete this item?',

  userinfo: 'User information',
  operatorinfo: 'Operation information',
  infodetails: 'Details information',
  feedbackinfo: 'Satisfaction level information',
  feedback: 'Satisfaction level',
  reason: 'Reason',
  imagefix: 'Post-repair image',
  noimage: 'No image',
  noimagefix: 'No post-repair image',
  talk: 'Chat',
  showpdf: 'Show PDF',
  improve: 'Approve',
  showimage: 'View image',
  send: 'Send',
  sir: 'Mr./Ms.',
  notfoundname: 'Name not found',
  typeing: 'Typing message...',
  enterdevice: 'Please select a device',
  entersubdevice: 'Please select a category of the device',
  confirmfixer: 'Confirm Work Assignment',
  confirmdetails: 'Are you sure you want to confirm this item?',
  files: 'Files',
  filesdone: 'Files (After Repair)',
  nofiles: 'No files',

  // Navigation bar page
  requestsearch: 'Repair request list',
  calendar: 'Preventive Maintenance (PM)',
  calendarView: 'Preventive Maintenance (PM)',
  updatesearch: 'Repair request list',
  adminsearch: 'Repair request list',
  usersearch: 'Employee list',
  dashboard: 'Report',
  settings: 'Settings',
  userform: 'Edit employee list',
  devicelist: 'Edit device list',
  departmentform: 'Edit department list',
  CategoryManagement: 'Edit problem categories',
  Expense: 'Edit expense list',
  deviceCate: 'Edit device categories',
  location: 'Edit location list',
  jobtitleEdit: 'Edit job titles',

  // Calendar
  nodetails: 'No details',
  start: 'Start',
  starttime: 'Start time',
  endtime: 'End time',
  end: 'End',
  devicename: 'Device name',
  details: 'Details',
  deleteconfirmEvent: 'Confirm delete event',
  title: 'Title',
  confirminput: 'Please fill in all the required information',
  adduser: 'Add member',
  edit: 'Edit',

  // User
  nosignature: 'No signature',
  active: 'Active',
  nonactive: 'Inactive',
  enable: 'Enable',
  nonuser: 'No member data',
  uploadimage: 'Upload profile image',
  drawsignature: 'Draw signature',
  clearsignature: 'Clear signature',
  update: 'Update',
  newadd: 'Add new',
  userlist: 'Employee list',
  employeeinfo: 'Employee information',
  fullname: 'Full name',
  signature: 'Signature',
  nonuserdetails: 'Employee data not found',
  youwant: 'Do you want to',
  yesorno: 'Yes or No',

  // Dashboard
  all: 'All',
  year: 'Year',
  month: 'Month',
  day: 'Day',
  fixrequest: 'Repair requests',
  totalall: 'Total number',
  totalcostall: 'Total cost',
  fixrequeststatus: 'Repair request status',
  expensefix: 'Repair expense',
  bath: 'Baht',
  sparecost: 'Spare part expense',
  alluser: 'All users',
  person: 'Person',
  devicestatuslist: 'Device status list',
  alldevice: 'All devices',
  pmlist: 'PM device list',
  nodata: 'No data',
  repairCount: 'Repair count',
  fixcostdevice: 'Repair cost by device',
  fixcost: 'Repair cost',
  sparecostdevice: 'Spare part cost by device',
  employeerole: 'Employee count by role',
  pmamount: 'Number of PM devices',
  getdevice: 'Date received',
  notfoundlist: 'No items found. Please try again.',
  searchdevice: 'Search for device',
  searchtitlename: 'Search by title',
  titlename: 'Title',

  adddevice: 'Add device',
  selectsearchtype: 'Select search type',
  nondevice: 'No device listed',
  sndevice: 'Device number',
  model: 'Model',
  locationname: 'Location',
  searchsndevice: 'Search by device number',
  searchnamedevice: 'Search by device name',
  searchmodel: 'Search by model',
  searchcate: 'Search by category',
  searchsubcate: 'Search by subcategory',
  searchuser: 'Search by user',
  searchdepartment: 'Search by department',
  searchlocation: 'Search by location',
  searchcost: 'Search by price',
  searchstatus: 'Search by status',
  catedevice: 'Main device category',
  subcatedevice: 'Subcategory of device',
  warrantydetails: 'Warranty information',
  warrantydetail: 'Warranty details',
  providerName: 'Service provider name',
  warrantytime: 'Warranty period (years, months, days)',
  expdate: 'Expiration date',
  nodatawarranty: 'No warranty information',
  nowarranty: 'No warranty',
  hardwaredetails: 'Hardware information',
  detailsinput: 'Enter details',
  nodetailshardware: 'No hardware details',
  devicestatus: 'Device status',
  assetType: 'Asset type',
  otherdetails: 'Additional information',
  detailsanother: 'Additional details',
  detailsanotherinput: 'Enter additional details',
  edituserdevice: 'Edit device user',
  zeroyear: '0 year',
  zeromonth: '0 month',
  zeroday: '0 day',
  use: 'In use',
  nonuse: 'Not in use',
  sellscrap: 'Sell scrap',
  rent: 'Rent',
  buy: 'Buy outright',
  vendor: 'Vendor name',
  warrantyday: 'Warranty period (days)',
  warrantyExp: 'Expiration date',
  exp: 'Expired',
  after: 'Remaining ',
  hour: 'hour',
  inday: 'Within today',
  confirmdelete: 'Are you sure you want to delete this item?',
  deviceinfodetails: 'Device details',
  warrantydevice: 'Device warranty details',
  fixhistory: 'Repair history',
  userdevicehistory: 'User device history',
  nondevicedetails: 'No device history data',
  outofdate: 'End of use date',
  startuse: 'Start using',
  enduse: 'End use',
  delconfirm: 'Confirm deletion',
  yes: 'Yes',
  searchworkername: 'Search for repair operator',
  workername: 'Name of repair operator',
  fixworker: 'Number of Tasks workers',
  repairstatusCount: 'Repair Status Count',
  fixstatusworker: 'List of Repair Status Counts',
  costdevice: 'Device count',
  statusfix: 'Service Type',
  pmcount: 'PM count',
  times: 'Time',
  confirmapprove: 'Confirm approval',
  dateselect: 'Please select a valid date',
  pmhistory: 'Maintenance History (PM)',

  // Department
  deptid: 'Department ID',
  adddept: 'Add department',
  editdept: 'Edit department',
  nodeptdetails: 'No department records',

  // Category
  editlist: 'Edit list',
  addcate: 'Add category',
  catename: 'Category name',
  subcatename: 'Subcategory name',
  add: 'Add',
  editsubcate: 'Edit subcategory',
  addsubcate: 'Add subcategory',
  reset: 'Reset',
  searchcateAndsubname: 'Search main/sub category',
  // Location
  searchlocationname: 'Location name',
  addlocation: 'Add location',
  editlocation: 'Edit location',
  nolocationlist: 'No location records',

  // Job title
  jobtitlename: 'Job title',
  addjobtitle: 'Add job title',
  selectdept: 'Select department',
  editjobtitle: 'Edit job title',
  nojobtitlelist: 'No job title records',

  // Others
  notfoundsearch: 'No search results found',
  pmdevice: 'Device',
  time: 'Duration',
  today: 'Today',
  datailsanother: 'Other Details',
  useddelete: 'In use and cannot be deleted',
  confirmapproveall: 'Confirm Approval All Request',
  confirmapprovealldetails: 'Are you sure you want to approve all repair requests?',
  Profile: 'Profile',
  logout: 'Logout',
  other: 'Others',

  // error page
  pagenotfound: 'Page Not Found',
  pagenotfounddetails: 'Oops! The requested URL was not found on this server',
  backhome: 'Back to home',

  delete: 'Delete',
  Collapse: 'Collapse',
  Expand: 'Expand',
  getjob: 'Get Job',
  phoneinput: 'Enter phone number / extension',
  resetpassword: 'Reset password',
  passwordold: 'Old Password',
  passwordnew: 'New Password',
  passwordconfirm: 'Confirm New Password',
  passwordUpdateSuccess: 'Update NewData Success !!',
  success: 'Success',
  headcheck: 'Awaiting Approval',

  quantity: 'Qty',
  unit: 'Unit',
  sn: 'S/N',
  sninput: 'Enter serial number',
  searchsn: 'Search by serial number',
}
